import {DateRangeFilter} from './DateRangeFilter';
import {Pagination} from './Pagination';
import {SavedListType} from './SavedListType';
import {SortDirection} from './SortDirection';

/**
 * @export
 * @type SavedListRequest
 */
export type SavedListRequest = {
    searchTypes?: Array<SavedListType>;
    /**
     * The name query to filter the saved searches.
     */
    nameQuery?: string;
    pagination: Pagination;
    createDateFilter?: DateRangeFilter;
    lastRunDateFilter?: DateRangeFilter;
    lastSharedDateFilter?: DateRangeFilter;
    sortDirection: SortDirection;
    sortField: SavedListRequestSortField;
}

export enum SavedListRequestSortField {
    NAME = 'NAME',
    CREATE_DATE = 'CREATE_DATE',
    LAST_RUN_DATE = 'LAST_RUN_DATE',
    LAST_SHARED_DATE = 'LAST_SHARED_DATE',
    SEARCH_LIST_TYPE = 'SEARCH_LIST_TYPE'
}